export default __webpack_public_path__ + "static/media/League_logo.b71cc59e.svg";